/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getInviteCodes.defs'
export { main as default } from './getInviteCodes.defs'
